<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="600">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-GOAL' : 'EDIT-GOAL') | translate }}</h3>
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="editForm" class="k-form">
    <div class="row">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'GOAL' | translate}} *
          </span>
          <input *ngIf="goalDictionary === ''" id="goalText" kendoTextBox formControlName="goalText" maxlength="255" />
          <kendo-autocomplete #singleSelect
            *ngIf="goalDictionary !== '' && ((isNew && allowFreeTextForNewGoals) || (!isNew))" [data]="allGoalsFiltered"
            [valueField]="'displayName'" [textField]="'displayName'" [virtual]="virtualGoal" class="w-100"
            [suggest]="true" [highlightFirst]="true" [filterable]="true" (filterChange)="filterAllGoals($event)"
            (close)="searchTerm=''" (click)="singleSelect.toggle(true)" formControlName="goalText" tabindex="2">
            <ng-template kendoAutoCompleteItemTemplate let-dataItem>
              <span innerHTML="{{ dataItem.displayName | highlight : searchTerm }}" class="ellipsis-text">
              </span>
            </ng-template>
          </kendo-autocomplete>
          <kendo-combobox *ngIf="goalDictionary !== '' && isNew && !allowFreeTextForNewGoals" id="goalText"
            class="w-100" formControlName="goalText" [data]="allGoalsFiltered" [textField]="'displayName'"
            [valueField]="'code'" [valuePrimitive]="true">
          </kendo-combobox>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="goalText.hasError('required') && goalText.touched ">
            {{'REQUIRED-GOAL' | translate}}
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label for="typesOfGoal" class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'TYPE-OF-GOAL' | translate}} *
          </span>
          <kendo-combobox id="typesOfGoal" class="w-100" formControlName="typesOfGoal" [data]="allTypesOfGoal"
            [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="false">
          </kendo-combobox>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="typesOfGoal.hasError('required') && typesOfGoal.touched ">
            {{'REQUIRED-TYPE-OF-GOAL' | translate}}
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label for="progress" class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'PROGRESS' | translate}} *
          </span>
          <kendo-combobox id="progress" class="w-100" formControlName="progress" [data]="allGoalsProgress"
            [textField]="'displayName'" [valueField]="'code'" [valuePrimitive]="false">
          </kendo-combobox>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="progress.hasError('required') && progress.touched ">
            {{'REQUIRED-PROGRESS' | translate}}
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'ACTION-PLAN' | translate}}
          </span>
          <textarea id="actionPlan" kendoTextArea class="w-100" formControlName="actionPlan" maxlength="4000" rows="2"></textarea>          
        </label>
      </div>
    </div>
  </form>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>

  <kendo-dialog-actions>
    <button *ngIf="!isNew" class="k-button k-primary" [disabled]="isNew" (click)="confirmDeleteDialogOpened = true"
      style="position:absolute;left:15px">{{ 'DELETE' | translate }}
    </button>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
      (click)="onSave($event)">{{
      'SAVE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- confirm erase dialog -->
<kendo-dialog *ngIf="confirmDeleteDialogOpened" (close)="confirmDeleteDialogOpened = false" [minWidth]="400">
  <kendo-dialog-titlebar>
    <h3>{{'DELETE-GOAL' | translate}}</h3>
  </kendo-dialog-titlebar>
  <label>{{'CONFIRM-DELETE-GOAL' | translate}}</label>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="confirmDeleteDialogOpened = false">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="onDelete($event); confirmDeleteDialogOpened = false">
      {{'YES' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>